import { Dispatch, SetStateAction } from 'react';

import { Radio } from '@mui/material';

import { isValidVideoPath } from '@utils/image';
import {
  ImageWrapper,
  UploadedImageView,
  StyledDeleteIcon,
  SvgWrapper,
  RadioWrappe,
} from './styled';

interface RenderImagesByBase64Props<T> {
  src: string;
  lengthOfImages: number;
  togetherImagesLength: number;
  mainImageUrl?: string | null;
  posibilityToMainImage: boolean;
  setState: Dispatch<SetStateAction<T>>;
  handleDeleteImage?: (str: string) => void;
  setMainImage?: (id: string) => void;
}

const RenderImagesByBase64 = <T, >({
  src,
  lengthOfImages,
  mainImageUrl,
  togetherImagesLength,
  posibilityToMainImage,
  setState,
  setMainImage,
  handleDeleteImage,
}: RenderImagesByBase64Props<T>) => {
  const handleMainImageSelection = () => {
    const [_, path] = src.split('images/');

    setMainImage?.(`images/${path}`);
  };

  const handleImageClick = () =>
    setState((prev) => ({
      ...prev,
      imageUrl: src,
      isViewImageModalOpen: true,
      isImageViewOpen: true,
      imageSrcForAction: src,
    }));

  const handleDelete = () => {
    handleDeleteImage?.(src);
    setState((prev) => ({
      ...prev,
      imageUrl: src,
      isDeleteModalOpen: true,
    }));
  };

  const renderContent = () => {
    if (src.includes('data:video') || isValidVideoPath(src)) {
      return (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video width="150" height="150" onClick={handleImageClick}>
          <source src={src} type="video/mp4" />
        </video>
      )
    }

    return (
      <UploadedImageView src={src} alt="product" onClick={handleImageClick} />
    )
  }

  const renderDeleteIcon = () => {
    if (mainImageUrl && src.includes(mainImageUrl) || lengthOfImages <= 1 || togetherImagesLength <= 1) {
      // main image or if there is one image
      return null
    }

    // here delete function
    return (
      <SvgWrapper onClick={handleDelete}>
        <StyledDeleteIcon />
      </SvgWrapper>
    )
  }

  return (
    <ImageWrapper>
      {posibilityToMainImage && src.includes('http') && (
      <RadioWrappe>
        <Radio
          name="isMain"
          className="radio"
          checked={!!mainImageUrl && src.includes(mainImageUrl)}
          onClick={handleMainImageSelection}
        />
      </RadioWrappe>
      )}
      {renderDeleteIcon()}
      {renderContent()}
    </ImageWrapper>
  );
};

export default RenderImagesByBase64;
